import React from "react";
import FaqItem from "./FaqItem";

const faqData = [
    {
        title: "Que faire après ma première connexion ?",
        description:
            "Commencez par compléter votre profil dans la section Profil & Abonnement. Remplissez toutes les informations obligatoires de votre société : nom commercial, statut juridique, logo, SIRET (obligatoire et unique), TVA et email principal (unique). Ces informations sont essentielles pour créer des devis et factures conformes."
    },
    {
        title: "Comment ajouter un client ?",
        description:
            "Avant de créer un devis ou une facture, ajoutez au moins un client dans la liste des clients. Cliquez sur 'Ajouter un client' et remplissez les informations nécessaires."
    },
    {
        title: "Comment créer un devis ?",
        description:
            "Après avoir ajouté un client, rendez-vous dans la section Devis. Chaque devis reçoit un numéro unique (ex : DEV-0001). Vous pouvez transformer le devis en facture via le bouton 'Transformer en facture'."
    },
    {
        title: "Comment générer et télécharger un PDF ?",
        description:
            "Pour chaque devis ou facture, utilisez le bouton PDF pour télécharger le document. Cela permet de partager facilement vos documents avec vos clients."
    },
    {
        title: "Comment personnaliser le PDF ?",
        description:
            "Vous pouvez configurer vos PDF en choisissant si vous souhaitez inclure le logo de votre société et la couleur du PDF. Cela permet de créer des documents professionnels et cohérents avec votre identité visuelle."
    },
    {
        title: "Comment relancer une facture impayée ?",
        description:
            "Dans la liste des factures, cliquez sur 'Relancer' et personnalisez le message avant l'envoi. Les relances suivantes sont automatiques tous les 15 jours tant que le statut de la facture reste non payé."
    },
    {
        title: "Quelles informations sont importantes pour la TVA ?",
        description:
            "Assurez-vous que le SIRET et le numéro de TVA sont corrects dans votre profil. Ces informations apparaîtront sur tous vos devis et factures officiels."
    },
    {
        title: "Puis-je utiliser un téléphone pour gérer mes documents ?",
        description:
            "Il est recommandé d’utiliser un ordinateur pour configurer le profil, ajouter des clients et créer des devis/factures afin d’éviter les erreurs et profiter d’une meilleure expérience utilisateur."
    }
];



const FaqList = () => {
    return (
        <section className="flex flex-col items-center lg:py-16 py-8 lg:gap-8 gap-4 px-1 text-center w-full ">
            <h2 className="font-bold font-Poppins text-blue-800
                text-2xl sm:text-2xl md:text-2xl lg:text-4xl text-center 
                leading-snug lg:leading-[4rem]">
                Besoin d’aide ? On a les réponses
            </h2>

            <div className="grid lg:grid-cols-2 grid-cols-1 gap-6 p-4">
                {faqData.map((faq, index) => (
                    <FaqItem
                        key={index}
                        title={faq.title}
                        description={faq.description}
                    />
                ))}
            </div>
        </section>

    );
};

export default FaqList;
